import { useDecorateRemoteCursors } from '@slate-yjs/react';
import { useCallback } from 'react';
export { getRemoteCaretsOnLeaf, getRemoteCursorsOnLeaf } from '@slate-yjs/react';
export const useDecorateRemoteCursorsV2 = () => {
    const decorate = useDecorateRemoteCursors();
    const decorateV2 = useCallback(({ entry }) => decorate(entry), [decorate]);
    return decorateV2;
};
//# sourceMappingURL=react.js.map